import { AxiosError } from 'axios';
import { RequestStrings } from './strings';

export function getErrorMessageFromAxiosError(error: AxiosError) {
  if (error.isAxiosError && error.code === AxiosError.ERR_NETWORK) {
    return RequestStrings.CONNECTION_ERROR_SHORT;
  }

  if (!error.response) {
    return RequestStrings.CONNECTION_ERROR_MSG;
  }

  if (!error.response.status || error.response.status <= 0) {
    return RequestStrings.CONNECTION_ERROR_MSG;
  }

  if (error.response.status === 422) {
    return RequestStrings.INVALID_INPUT_MSG;
  }

  const errorResponse = error.response.data as {
    error_message?: string;
    message?: string;
  };

  return errorResponse.error_message || errorResponse.message || error.message;
}
